import React, {Component} from 'react';

import BrandSignup from './brand_signup';
import Footer from './footer';

export default class ContactForm extends Component {
    constructor(){
        super();
        this.displayThankYou = this.displayThankYou.bind(this);
        this.setClasses = this.setClasses.bind(this);
        this.displayHeader = this.displayHeader.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.state = {
            formSubmitted: false
        };
    }

    displayThankYou(){
        this.setState({
            formSubmitted: true
        });
    }

    setClasses(){
        const {page} = this.props;

        return page === 'brand-ambassadors' ? 'gr-12 contact-form brand-ambassadors-contact-form' : 'gr-12 contact-form branded-content-contact-form'
    }

    displayHeader(){
        const {page} = this.props;

        return page === 'brand-ambassadors' ? (
            <div className='contact-form-header'>
                <h1 className='brand-ambassadors-contact-form-header'>Ready to unlock the power of brand ambassadors?</h1>
            </div>
        ) : null;
    }

    displayForm(){
        const {formSubmitted} = this.state;
        const {page, displayStatic} = this.props;
        const thankYouGif = require('images/checkmark.gif');
        const classes = this.setClasses();
        const header = this.displayHeader();

        if(!formSubmitted){
            return(
                <div id='contact-form' className={classes}>
                    {header}
                    <div className='contact-form-background'>
                        <div className='contact-form-background-blur-container'>
                            <div className='contact-form-background-blur'></div>
                        </div>
                        <div className='contact-form-body'>
                            <BrandSignup
                                page={page}
                                formSubmitted={formSubmitted}
                                displayStatic={displayStatic}
                                displayThankYou={this.displayThankYou} />
                        </div>
                    </div>
                    <Footer page={page} />
                </div>
            );
        } else {
            return(
                <div id='contact-form' className={classes}>
                    <div className='contact-form-background'>
                        <div className='contact-form-background-blur-container'>
                            <div className='contact-form-background-blur'></div>
                        </div>
                        <div className='contact-form-thank-you'>
                            <span>Thank You!</span>
                            <img className='show hide@xs' src={thankYouGif} />
                        </div>
                    </div>
                    <Footer page={page} />
                </div>
            );
        }
    }

    render(){
        const form = this.displayForm();

        return form;
    }
}



// WEBPACK FOOTER //
// ./web/js/components/contact_form.js